/**
 * Environment detection utilities
 * Used to conditionally enable dev-only features like the Feature Flag Manager
 */

/**
 * Check if running in a development environment
 * Returns true for: localhost, staging (.stag. or stag-), long-running (.long.), ephemeral (.ephemeral.in)
 * Uses hostname (not host) to handle ports correctly (e.g., something.ephemeral.in:8443)
 */
export const isDevEnv = () => {
    const hostname = window.location.hostname;
    return (
        hostname.startsWith('localhost') ||
        hostname.startsWith('stag-') ||
        hostname.includes('.stag.') ||
        hostname.includes('.long.') ||
        hostname.endsWith('.ephemeral.in')
    );
};

/**
 * Check if running on localhost specifically
 */
export const isLocalhost = () => {
    return window.location.hostname.startsWith('localhost');
};
